import { Box, makeStyles, TextField, Zoom } from "@material-ui/core";
import InfoIcon from "src/components/Icon/InfoIcon";
import { THEME_MODE } from "src/config/constants";

const useStyles = makeStyles((theme) => ({
  textField: {
    "& .MuiFormLabel-root": {
      color: `${theme.palette.text.hint} !important`,
    },
    "& .MuiInputLabel-shrink": {
      color: `${theme.palette.text.highContrast} !important`,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderRadius: "8px",
      },
      backgroundColor: theme.palette.type === THEME_MODE.DARK ? "#031527" : "#F7F7F7",
      borderRadius: "8px",
    },
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  tooltip: {
    fontSize: 16,
    maxWidth: (props) => props.maxWidth ?? "400px",
  },
  iconButtonRoot: {
    color: "inherit",
    padding: 0,
  },
  muiSvgIconRoot: {
    fontSize: 16,
    color: "#D7DFEC",
    margin: "auto",
  },
}));

export default function StyledTextField({ info, textProps, rootProps }) {
  const cls = useStyles();

  return (
    <Box width="100%" display="flex" alignItems="center" {...rootProps}>
      <TextField size="small" variant="outlined" className={cls.textField} {...textProps} />
      {info && <InfoIcon TransitionComponent={Zoom} title={info} />}
    </Box>
  );
}
